import React from "react";
import isNotEmpty from "../../../utils/isNotEmpty";
import TextAtm from "../../atoms/TextAtm";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
import { ExpandedContent, Wrapper } from "./ConfigBoxMol.styled";
function ConfigBoxMol(_ref) {
  var label = _ref.label,
    text = _ref.text,
    configElement = _ref.configElement,
    isExpanded = _ref.isExpanded,
    expandedContent = _ref.expandedContent,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Wrapper, {
    $hasOnClick: !!onClick,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "space-between",
    alignItems: "center",
    gapSpace: 1,
    wrap: "wrap"
  }, /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small3",
    pushSpace: isNotEmpty(text) ? 0.5 : 0
  }, label), isNotEmpty(text) ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium"
  }, text) : null), configElement), /*#__PURE__*/React.createElement(ExpandedContent, {
    isOpen: isExpanded
  }, expandedContent));
}
export default ConfigBoxMol;